import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { createCropValidationSchema } from "../../components/Custom/ValidationSchema";
import { createProgramInput } from "../../api/programs";

const validationSchema = createCropValidationSchema();

export default function CreateProgramInput() {
  const navigate = useNavigate();
  const { programId } = useParams();

  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { errors, validate } = useFormValidation(formData, validationSchema);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      program: programId,
    };
    await createProgramInput(payload);
    navigate(-1);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Input Supply")}</CustomTitle>

            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Input Supply Name")}
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.name}
              helperText={errors.name}
            />
            <CustomButton onClick={handleSubmit}>{t("Save")}</CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
